import { render, staticRenderFns } from "./AdminsList.vue?vue&type=template&id=40ec23a3&scoped=true&"
import script from "./AdminsList.vue?vue&type=script&lang=js&"
export * from "./AdminsList.vue?vue&type=script&lang=js&"
import style0 from "./AdminsList.vue?vue&type=style&index=0&id=40ec23a3&prod&lang=scss&scoped=true&"
import style1 from "./AdminsList.vue?vue&type=style&index=1&id=40ec23a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec23a3",
  null
  
)

export default component.exports